import { pipe, Option } from "effect";

export type EnvVarGetter = () => string | undefined;

export const isEnvVarOn = (getter: EnvVarGetter) => {
  const value = getter();
  return Boolean(value && value === "true");
};

export const getEnvVarOrWarn = (getter: EnvVarGetter) =>
  pipe(
    getter(),
    Option.fromNullable,
    Option.filter((str) => !!str),
    Option.getOrElse(() => {
      console.warn(
        `Environment variable is falsey: ${getter.toString()} - returning ''`
      );

      return "";
    })
  );

export const getEnvVarOrThrow = (getter: EnvVarGetter) =>
  pipe(
    getter(),
    Option.fromNullable,
    Option.filter((str) => !!str),
    Option.getOrThrowWith(
      () => new Error(`Environment variable is falsey: ${getter.toString()}`)
    )
  );
